import { NotificationHistoryItem, NotificationListResponse } from '../types';
import { apiService } from '../services/api';

// Батчинг записи, чтобы не слать много POST подряд
let pending: NotificationHistoryItem[] = [];
let flushTimer: number | null = null;
const FLUSH_DELAY_MS = 500; // сгруппировать уведомления за полсекунды

const scheduleFlush = () => {
  if (flushTimer != null) return;
  flushTimer = window.setTimeout(async () => {
    const toSend = pending.slice();
    pending = [];
    flushTimer = null;
    if (toSend.length === 0) return;
    try {
      await apiService.recordServerNotificationsBulk(toSend);
      fireUnreadUpdated();
      // Сообщаем страницам, что история пополнилась (одним событием на батч)
      fireHistoryUpdated();
    } catch {}
  }, FLUSH_DELAY_MS) as unknown as number;
};

// События обновления сохраним для обратной совместимости UI
const fireHistoryUpdated = () => {
  try { if (typeof window !== 'undefined') window.dispatchEvent(new Event('notification-history-updated')); } catch {}
};
const fireUnreadUpdated = () => {
  try { if (typeof window !== 'undefined') window.dispatchEvent(new Event('notification-unread-updated')); } catch {}
};

export const recordNotification = async (params: {
  app_id?: string;
  title: string;
  body: string;
  devices_count?: number;
  total_price_minor?: number;
}): Promise<NotificationHistoryItem | null> => {
  const item: NotificationHistoryItem = {
    id: `${Date.now()}_${Math.random().toString(36).slice(2, 10)}`,
    timestamp: Date.now(),
    app_id: params.app_id,
    title: params.title,
    body: params.body,
    devices_count: params.devices_count,
    total_price_minor: params.total_price_minor,
  };
  try {
    pending.push(item);
    scheduleFlush();
    // не ждём сеть
    return item;
  } catch {
    return null;
  }
};

export const getNotificationHistory = async (): Promise<NotificationHistoryItem[]> => {
  try {
    const res: NotificationListResponse = await apiService.getServerNotificationHistory(1000);
    return Array.isArray(res.items) ? res.items : [];
  } catch {
    return [];
  }
};

export const clearNotificationHistory = async (): Promise<void> => {
  try {
    await apiService.clearServerNotificationHistory();
    fireHistoryUpdated();
    fireUnreadUpdated();
  } catch {}
};

export const getReadIds = async (): Promise<Set<string>> => {
  try {
    const res = await apiService.getServerNotificationHistory(1000);
    const set = new Set<string>(res.items.filter(i => i.read).map(i => i.id));
    return set;
  } catch {
    return new Set<string>();
  }
};

// Батчинг пометки прочитанного (глобально)
const pendingReadIds: Set<string> = new Set();
let flushReadTimer: number | null = null;
const scheduleReadFlush = () => {
  if (flushReadTimer != null) return;
  flushReadTimer = window.setTimeout(async () => {
    const ids = Array.from(pendingReadIds);
    pendingReadIds.clear();
    flushReadTimer = null;
    if (ids.length === 0) return;
    try {
      await apiService.markServerNotificationsRead(ids);
      fireUnreadUpdated();
    } catch {}
  }, 300) as unknown as number;
};

export const markAsRead = async (ids: string[]): Promise<void> => {
  try {
    if (!ids || ids.length === 0) return;
    for (const id of ids) pendingReadIds.add(id);
    scheduleReadFlush();
    // возвращаемся сразу — сеть отправится батчем позднее
  } catch {}
};

export const getUnreadCount = async (): Promise<number> => {
  try {
    const res = await apiService.getServerNotificationHistory(1);
    return res.unread_count || 0;
  } catch {
    return 0;
  }
};

